export const billingTestIds = {
  // Page-level containers (per view)
  accountPage: 'billing-account-page',
  workspacePage: 'billing-workspace-page',
  platformPage: 'billing-platform-page',

  // Account view — shared sections
  currentPlanSection: 'billing-currentplan-section',
  usageMetersSection: 'billing-usagemeters-section',
  usageHeadline: 'billing-usage-headline',
  usageMetersLoading: 'billing-usagemeters-loading',
  usageMetersEmpty: 'billing-usagemeters-empty',
  quotaUsageSection: 'billing-quotausage-section',
  quotaLoading: 'billing-quota-loading',
  quotaUnavailable: 'billing-quota-unavailable',
  customizeWorkspaceButton: 'billing-customize-workspace-button',
  clearCustomizeButton: 'billing-clear-customize-button',
  workspacePickerButton: (name: string) => `billing-workspace-pick-${name}` as const,
  creditsSection: 'billing-credits-section',
  creditsSummary: 'billing-credits-summary',
  workspacePicker: 'billing-workspace-picker',
  paymentSection: 'billing-payment-section',
  paymentPlansButton: 'billing-payment-plans-button',
  invoicesSection: 'billing-invoices-section',
  customerUsageSection: 'billing-customer-usage-section',
  customerUsageTable: 'billing-customer-usage-table',
  customerUsageRow: (name: string) => `billing-customer-usage-row-${name}` as const,

  // Customer tiers subsection
  tiersSection: 'billing-tiers-section',
  tiersCreateButton: 'billing-tiers-create-button',
  tiersLoading: 'billing-tiers-loading',
  tiersEmptyState: 'billing-tiers-empty-state',
  tiersErrorBanner: 'billing-tiers-error-banner',
  tiersTable: 'billing-tiers-table',
  tierRow: (id: string) => `billing-tier-row-${id}` as const,
  tierEditButton: (id: string) => `billing-tier-edit-button-${id}` as const,
  tierDeleteButton: (id: string) => `billing-tier-delete-button-${id}` as const,
  tierForm: 'billing-tier-form',
  tierNameInput: 'billing-tier-name-input',
  tierRoleSelect: 'billing-tier-role-select',
  tierConnectorsAllButton: 'billing-tier-connectors-all-button',
  tierConnectorButton: (id: string) => `billing-tier-connector-${id}-button` as const,
  tierLimitInput: (key: string) => `billing-tier-limit-${key}-input` as const,
  tierCustomerCount: (id: string) => `billing-tier-customer-count-${id}` as const,
  tierPresetButton: (preset: string) => `billing-tier-preset-${preset.toLowerCase()}-button` as const,
  tierConnectorsSomeButton: 'billing-tier-connectors-some-button',
  tierSummary: 'billing-tier-summary',
  tierSaveButton: 'billing-tier-save-button',
  tierCancelButton: 'billing-tier-cancel-button',

  // Platform view
  platformLoading: 'billing-platform-loading',
  platformCreatePlanButton: 'billing-platform-create-plan-button',
  platformPlanPriceInput: (tier: string) => `billing-platform-plan-price-input-${tier}` as const,
  platformStatsSection: 'billing-platform-stats-section',
  platformAccountsSection: 'billing-platform-accounts-section',
  platformAccountSearchInput: 'billing-platform-account-search-input',
  platformAccountsTable: 'billing-platform-accounts-table',
  platformAccountRow: (name: string) => `billing-platform-account-row-${name}` as const,
  platformPlanRow: (tier: string) => `billing-platform-plan-row-${tier}` as const,
  platformPlanEditButton: (tier: string) => `billing-platform-plan-edit-button-${tier}` as const,

  // Plan change request flow (customer side)
  requestPlanButton: 'billing-request-plan-button',
  pendingRequestBanner: 'billing-pending-request-banner',
  pendingRequestCancelButton: 'billing-pending-request-cancel-button',
  planChangeModal: 'plan-change-modal',
  planChangeModalCloseButton: 'plan-change-modal-close-button',
  planChangeOption: (tier: string) => `plan-change-option-${tier}` as const,
  planChangeContactSalesButton: 'plan-change-contact-sales-button',
  planChangeContactSalesFooterButton: 'plan-change-contact-sales-footer-button',
  planChangeSalesEmailFallback: 'plan-change-sales-email-fallback',
  planChangeSalesEmailCopyButton: 'plan-change-sales-email-copy-button',
  planChangeSubmitButton: 'plan-change-submit-button',
} as const;
